import { EventBase } from '@models/analyticsEvents.types';

import { isLocalOrTestEnv } from './featureFlags';

export const sendGoogleAnalyticsEvent = <T extends EventBase = EventBase>(
  data: T
): void => {
  window.dataLayer = window.dataLayer || [];

  if (data) {
    if (isLocalOrTestEnv) console.debug(`[DataLayer] ${data.event}:`, data);

    window.dataLayer.push(data);
  }
};
